import * as React from 'react';
import { clsx } from 'clsx';

import * as styles from './styles.css';

import { UIHeading4, UIText1, UIText2, IconPhone16, IconMail16, IconInternet16 } from '@cian/ui-kit';
import { IManagementCompanyFullSchema } from 'shared/repositories/bti/entities/management_companies/ManagementCompanyFullSchema';

export interface IManagementCompanyProps {
  data: IManagementCompanyFullSchema;
}

export const ManagementCompany: React.FC<IManagementCompanyProps> = ({ data }) => {
  const { name, address, phones, email, site, sitePretty, openingHours, chiefName } = data;

  return (
    <div className={styles['container']}>
      <div className={styles['company-name']}>
        <div className={styles['company-name-title']}>
          <UIHeading4>{name}</UIHeading4>
        </div>
        {address && <UIText2>{address}</UIText2>}
      </div>
      <div className={styles['content']}>
        {(phones || email || site) && (
          <div className={styles['content-col']}>
            <div className={styles['content-title']}>
              <UIText2 color="gray60_100">Контакты</UIText2>
            </div>
            <div className={styles['contacts']}>
              {phones && (
                <div data-testid="ManagementCompany_Phones">
                  {phones.slice(0, 3).map((phone, i) => {
                    return (
                      <div key={i} className={styles['contact-item']}>
                        <IconPhone16 color="primary_100" />
                        <UIText1 color="primary_100">
                          <a href={`tel:${phone.replace(/[^+\d]/g, '')}`}>{phone}</a>
                        </UIText1>
                      </div>
                    );
                  })}
                </div>
              )}
              {(email || site) && (
                <div data-testid="ManagementCompany_Web">
                  {email && (
                    <div className={styles['contact-item']}>
                      <IconMail16 color="primary_100" />
                      <UIText1 color="primary_100">
                        <a href={`mailto:${email}`}>{email}</a>
                      </UIText1>
                    </div>
                  )}
                  {site && (
                    <div className={styles['contact-item']}>
                      <IconInternet16 color="primary_100" />
                      <UIText1 color="primary_100">
                        <a href={site}>{sitePretty}</a>
                      </UIText1>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
        {openingHours && (
          <div data-testid="ManagementCompany_OpeningHours" className={clsx(styles['content-col'], styles['worktime'])}>
            <div className={styles['content-title']}>
              <UIText2 color="gray60_100">Время работы</UIText2>
            </div>
            {openingHours.map(obj => {
              const key = Object.keys(obj)[0] as keyof object;

              return (
                <div key={key} className={clsx(styles['contact-item'], styles['justify'])}>
                  <div>
                    <UIText1>{key}</UIText1>
                  </div>
                  <div>
                    {(obj[key] as string[]).map((item, i) => {
                      return <UIText1 key={i}>{item}</UIText1>;
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {chiefName && (
          <div data-testid="ManagementCompany_ChiefName" className={styles['content-col']}>
            <div className={styles['content-title']}>
              <UIText2 color="gray60_100">Руководитель</UIText2>
            </div>
            <UIText1>{chiefName}</UIText1>
          </div>
        )}
      </div>
    </div>
  );
};

ManagementCompany.displayName = 'ManagementCompany';
